import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-information-message',
  templateUrl: './information-message.component.html',
  styleUrls: ['./information-message.component.scss'],
})
export class InformationMessageComponent {
  @Input() infoText: string;
  @Input() iconClass: string;
  @Input() mode: 'info' | 'warning' | 'error' = 'info';
  @Input() background: 'default' | 'warning' | 'inherit' = 'default';
  @Input() title: string;
  @Input() customStyles: Record<string, string>;
  @Input() fontSize: number = 12;
}
